<ng-container>
  <nb-card size="small" class="nb-card">
    <nb-card-body>

      <ng-select class="select-modal" [items]="catalogs"
                 #selectElement
                 [virtualScroll]="true"
                 [loading]="loading"
                 [closeOnSelect]="false"
                 [multiple]="true"
                 [selectableGroup]="true"
                 placeholder="Поиск каталогов"
                 appendTo="body"
                 (scroll)="onScroll($event)"
                 (scrollToEnd)="onScrollToEnd()"
                 bindLabel="header"
                 i18n-placeholder="@CatalogsSearch"
                 bindValue="id"
                 (add)="toggle(true, $event)"
                 (remove)="toggle(false,$event.value)"
                 [(ngModel)]="selectedCatalogs">

        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input *ngIf="productModel.catalogId !== item.id && item.lastLevel" id="item-{{index}}" type="checkbox"
                 [ngModel]="item$.selected" (ngModelChange)="toggle($event, item)"/>
          <span [title]="item.header" [innerHTML]="item.header" style="white-space: pre"></span>
        </ng-template>
      </ng-select>
    </nb-card-body>
  </nb-card>
</ng-container>
